// assets
import { IconUsers } from '@tabler/icons';
import permissioncheck from 'utils/permissioncheck';

// ==============================|| UTILITIES MENU ITEMS ||============================== //
const children = [
  {
    id: 'parent',
    perm: 'student.read',
    title: 'Orang Tua',
    type: 'item',
    url: '/parent/all',
    icon: IconUsers,
    breadcrumbs: false
  }
];
const data = {
  id: 'parent',
  title: '',
  type: 'group',
  children: []
};

children.forEach((element) => {
  if (permissioncheck(element.perm)) {
    data.children.push(element);
  }
});

export default data;
